import { AbstractControl, ValidatorFn } from '@angular/forms';

export const cpfValidator: ValidatorFn = (
  control: AbstractControl,
): { [key: string]: boolean } | null => {
  if (control.value !== '' && control.value !== null) {
    let cpf = control.value;
    if (
      cpf == '0'.repeat(11) ||
      cpf == '1'.repeat(11) ||
      cpf == '2'.repeat(11) ||
      cpf == '3'.repeat(11) ||
      cpf == '4'.repeat(11) ||
      cpf == '5'.repeat(11) ||
      cpf == '6'.repeat(11) ||
      cpf == '7'.repeat(11) ||
      cpf == '8'.repeat(11) ||
      cpf == '9'.repeat(11)
    ) {
      return { CPFinvalid: true };
    } else {
      let sum;
      let rest;
      sum = 0;
      for (let i = 1; i <= 9; i++)
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (11 - i);
      rest = (sum * 10) % 11;

      if (rest == 10 || rest == 11) rest = 0;
      if (rest != parseInt(cpf.substring(9, 10))) return { CPFinvalid: true };

      sum = 0;
      for (let i = 1; i <= 10; i++)
        sum = sum + parseInt(cpf.substring(i - 1, i)) * (12 - i);
      rest = (sum * 10) % 11;

      if (rest == 10 || rest == 11) rest = 0;
      if (rest != parseInt(cpf.substring(10, 11))) return { CPFinvalid: true };
      return null;
    }
  } else return null;
};
